import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

class Page extends Component {
  static propTypes = {
    children: PropTypes.node,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return <PageCont {...this.props}>{this.props.children}</PageCont>;
  }
}

const PageCont = styled.section`
  display: block;
`;

export default Page;
